import { getItem, setItem } from "../../plugins/localStorage"

const state = {
  appVersion: process.env.VUE_APP_VERSION || "0",
  question_guid: null,
  itemsPerLine: 7,
  realItemsPerLine: 7,
  realItemsPerLabel: [],
  itemSizeWithMargins: {
    width: process.env.VUE_APP_MEDIUM_SIZE,
    height: process.env.VUE_APP_MEDIUM_SIZE,
  },
  gridMode: "grid",
  likesDisplay: "number",
  tops: "10%",
  idsDisplay: {
    number: true,
    label: true,
  },
  orderedBy: "numbers",
  filter: null,
  deselect: true,
}

const getters = {
  deselect: (state) => {
    return state.deselect
  },
}

const actions = {
  saveOptions({ state }) {
    let optionsToSave = Object.assign({}, state)
    delete optionsToSave["orderedBy"]
    delete optionsToSave["filter"]
    delete optionsToSave["realItemsPerLine"]
    delete optionsToSave["realItemsPerLabel"]

    setItem({ name: "options", value: optionsToSave })
  },

  async setOptionsFromSaved({ commit }) {
    let options = getItem("options")
    // let options = getItem("options[" + question_guid + "]")
    if (options) {
      commit("setOptions", options)
    }
    /* else {
      commit("setOptions", { question_guid: question_guid })
    }*/
  },

  setItemsPerLine({ commit, rootState }, itemsPerLine) {
    let itemSizeWithMargins = { width: 0, height: 0 }
    switch (itemsPerLine) {
      case 5:
        itemSizeWithMargins.width =
          parseInt(process.env.VUE_APP_BIG_SIZE) +
          parseInt(process.env.VUE_APP_BIG_SIZE / 20) +
          parseInt(process.env.VUE_APP_BIG_SIZE / 10)
        break
      case 7:
        itemSizeWithMargins.width =
          parseInt(process.env.VUE_APP_MEDIUM_SIZE) +
          parseInt(process.env.VUE_APP_MEDIUM_SIZE / 20) +
          parseInt(process.env.VUE_APP_MEDIUM_SIZE / 10)
        break
      case 9:
        itemSizeWithMargins.width =
          parseInt(process.env.VUE_APP_SMALL_SIZE) +
          parseInt(process.env.VUE_APP_SMALL_SIZE / 20) +
          parseInt(process.env.VUE_APP_SMALL_SIZE / 10)
        break
    }
    if (rootState.question.max_chars === "30") {
      itemSizeWithMargins.height /= 1.5
    } else {
      itemSizeWithMargins.height = itemSizeWithMargins.width
    }

    commit("setItemsPerLine", { itemsPerLine, itemSizeWithMargins })
  },
}

const mutations = {
  resetRealItemsPerLabel(state) {
    state.realItemsPerLabel = []
  },

  setRealItemsPerLine(state, realItemsPerLine) {
    state.realItemsPerLine = realItemsPerLine
  },

  setRealItemsPerLabel(state, realItemsCount) {
    state.realItemsPerLabel.push(realItemsCount)
  },

  setLikesDisplay(state, likesDisplay) {
    state.likesDisplay = likesDisplay
    this.dispatch("grid/saveOptions")
  },

  setTops(state, tops) {
    state.tops = tops
    this.dispatch("grid/saveOptions")
    this.commit("answers/setTops", tops)
  },

  setOrderedBy(state, { orderedBy, labelGuidsOrdered }) {
    if (orderedBy !== null) {
      this.commit("answers/setOrderedBy", { orderedBy, labelGuidsOrdered })
    }

    if (orderedBy === "reorder") {
      state.orderedBy = "numbers"
      return
    }

    state.orderedBy = orderedBy
  },

  setFilter(state, filter) {
    if (state.filter === filter) {
      state.filter = null
    } else {
      state.filter = filter
    }
    // this.dispatch("grid/saveOptions")
    this.commit("answers/setFilter", state.filter)
    this.commit("grid/setOrderedBy", { orderedBy: null })
  },

  toggleIdsDisplay(state, idsDisplay) {
    state.idsDisplay[idsDisplay] = !state.idsDisplay[idsDisplay]
    this.dispatch("grid/saveOptions")
  },

  toggleDeselect(state) {
    state.deselect = !state.deselect
    this.dispatch("grid/saveOptions")
  },

  setItemsPerLine(state, { itemsPerLine, itemSizeWithMargins }) {
    state.itemsPerLine = itemsPerLine
    state.itemSizeWithMargins.width = itemSizeWithMargins.width
    state.itemSizeWithMargins.height = itemSizeWithMargins.height

    this.dispatch("grid/saveOptions")
  },

  setOptions(state, options) {
    for (const property in options) {
      state[property] = options[property]
    }
  },

  setGridMode(state, mode) {
    let fromGridMode = state.gridMode
    if (state.gridMode !== mode) {
      state.gridMode = mode
      this.dispatch("grid/saveOptions")
      this.commit("grid/setFilter", null)
    }

    if (mode === "group") {
      this.commit("answers/inlineGroups", fromGridMode)
    } else {
      this.commit("answers/removeAllEOL")
    }

    if (mode !== "label" && fromGridMode === "label") {
      this.commit("labels/deselectAll")
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
